__turbopack_context__.v({
  "checkbox": "MultiSelect-module__8J12Oa__checkbox",
  "count": "MultiSelect-module__8J12Oa__count",
  "does-not-exist": "MultiSelect-module__8J12Oa__does-not-exist",
  "heading": "MultiSelect-module__8J12Oa__heading",
  "hideScrollbar": "MultiSelect-module__8J12Oa__hideScrollbar",
  "js-has-pseudo": "MultiSelect-module__8J12Oa__js-has-pseudo",
  "labelWrapper": "MultiSelect-module__8J12Oa__labelWrapper",
  "listbox": "MultiSelect-module__8J12Oa__listbox",
  "listboxWithApplyButton": "MultiSelect-module__8J12Oa__listboxWithApplyButton",
});
